import React from 'react';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import { Field } from 'redux-form';
import { renderCriteriaOptions, renderMultiSelect } from '../FormFields/reduxFormRenderers';
import { useAttributeSelectors } from './hooks';
import { useLandingPageGroupsDtos } from '../../views/LandingPageGroups/queries';
import { useLandingPagesDtos } from '../../views/LandingPages/queries';

const CriteriaLandingPageIncludes = () => {
  const { criteriaLandingPageGroupIncludeExclude, criteriaLandingPageIncludeExclude } = useAttributeSelectors();
  const { data: landingPageGroups = [] } = useLandingPageGroupsDtos();
  const { data: landingPages = [] } = useLandingPagesDtos();

  return (
    <div>
      <Grid container spacing={2} sx={{ mt: 1, alignItems: 'start' }}>
        <Grid size={{ xs: 12, lg: 2 }}>
          <Typography variant='h5'>Landing Page Groups</Typography>
        </Grid>
        <Grid size={{ xs: 12, lg: 2 }}>
          <Field name='criteriaLandingPageGroupIncludeExclude' component={renderCriteriaOptions} type='select' />
        </Grid>
        {(criteriaLandingPageGroupIncludeExclude === 'Include' ||
          criteriaLandingPageGroupIncludeExclude === 'Exclude') && (
          <Grid size={{ xs: 12, lg: 4 }}>
            <Field
              name='criteriaLandingPageGroupIds'
              component={renderMultiSelect}
              data={landingPageGroups}
              dataKey='id'
              textField='name'
            />
          </Grid>
        )}
      </Grid>
      <Grid container spacing={2} sx={{ mt: 1, alignItems: 'start' }}>
        <Grid size={{ xs: 12, lg: 2 }}>
          <Typography variant='h5'>Landing Pages</Typography>
        </Grid>
        <Grid size={{ xs: 12, lg: 2 }}>
          <Field name='criteriaLandingPageIncludeExclude' component={renderCriteriaOptions} type='select' />
        </Grid>
        {(criteriaLandingPageIncludeExclude === 'Include' || criteriaLandingPageIncludeExclude === 'Exclude') && (
          <Grid size={{ xs: 12, lg: 4 }}>
            <Field
              name='criteriaLandingPageIds'
              component={renderMultiSelect}
              data={landingPages}
              dataKey='id'
              textField={(item) => item?.offer?.name || 'Unnamed Offer'}
            />
          </Grid>
        )}
      </Grid>
    </div>
  );
};

export default CriteriaLandingPageIncludes;
